import { rgba } from 'polished'
import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'
import { ClinStyledButton } from '../../../../components/ClinButton/ClinButton.styles'
import { mediaQuery } from '../../../../utils/mediaQuery'

const mobileUpBreakpoint = ClinTheme.breakpoints[1]

export const StyledAddresses = styled.div({
  marginTop: ClinTheme.space[3],
  borderTop: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.midGrey}`,
  [mediaQuery(mobileUpBreakpoint)]: {
    marginTop: ClinTheme.space[4]
  }
})

export const StyledAddress = styled.div({
  paddingTop: ClinTheme.space[4],
  paddingBottom: ClinTheme.space[4],
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.midGrey}`,
  label: {
    marginBottom: 0
  }
})

export const StyledSubmit = styled.div({
  paddingTop: ClinTheme.space[4],
  paddingBottom: ClinTheme.space[4],
  [mediaQuery(mobileUpBreakpoint)]: {
    marginTop: ClinTheme.space[3]
  }
})

export const StyledOverlayLoader = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  background: rgba(ClinTheme.colors.white, 0.95)
})

export const StyledNewAddressCta = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  marginTop: ClinTheme.space[4],

  [`${ClinStyledButton}`]: {
    border: 'none'
  },

  [mediaQuery(mobileUpBreakpoint)]: {
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
})

export const StyledNewAddressText = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',

  [`${ClinStyledButton}`]: {
    border: 'none'
  }
})

export const StyledActions = styled.div({
  display: 'inline-flex',
  flexDirection: 'column-reverse',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  width: '100%',

  'button:last-of-type': {
    marginBottom: ClinTheme.space[3]
  },

  [mediaQuery(mobileUpBreakpoint)]: {
    flexDirection: 'row',
    flexWrap: 'nowrap',

    button: {
      marginBottom: 0,
      marginRight: ClinTheme.space[3]
    },

    'button:last-of-type': {
      marginBottom: 0
    }
  }
})
